export default __webpack_public_path__ + "static/media/apache_cassandra_logo_icon_170572.572251f1.svg";